import axios from 'axios';
import { baseUrl } from './base';

export interface AcceptInvitePayload {
  token: string;
  tempPassword: string;
  password: string;
  passwordConfirmation: string;
}

export async function acceptInvite(payload: AcceptInvitePayload) {
  const res = await axios.post(`${baseUrl.TERMINAL}/user-management/users/invite/member/confirm`, {
    ...payload,
  });
  return res.data;
}
